import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SharedSettings } from '../../../../shared/src/lib/models/shared-settings';
import { ActivityBlockingService } from '../../../../shared/src/lib/services/activity-blocking.service';
import {Product, ProductSubinventorySummary, PsProduct} from '../models/product';
import {BehaviorSubject, Observable, of, Subscription} from 'rxjs';
import { combineLatest } from 'rxjs';
import {filter, map, tap} from 'rxjs/operators';
import { BayType } from '../models/bay-type';
import { url } from '../helpers/url';
import { DateTime } from 'luxon';

@Injectable({
    providedIn: 'root'
})
export class ProductListService {
    constructor(
            private http: HttpClient,
            private settings: SharedSettings,
            private activityService: ActivityBlockingService) {
    }

    private updateFields(product: Product): void {
        if (!product.maxLoadQuantity)
            product.maxLoadQuantity = 1000000;

        product.label = `${product.itemNumber} - ${product.itemDescription}`;
    }

    public getProducts(siteId: string): Observable<ProductSubinventorySummary> {
        const handle = this.activityService.StartWorking('ProductListService');
        return this.http.get<ProductSubinventorySummary>(this.settings.apiBaseUrl + url`sites/${siteId}/products`)
            .pipe(map(currentProducts => {
                this.activityService.FinishWorking(handle);
                currentProducts.products.forEach(p => { this.updateFields(p); });
                currentProducts.products.sort((l, r) => l.label.localeCompare(r.label));
                return currentProducts;
            }));
    }

    public getAllProducts(): Observable<Product[]> {
        return this.http.get<Product[]>(this.settings.apiBaseUrl + url`products`)
            .pipe(map(products => {
                products.forEach(p => { this.updateFields(p); });
                products.sort((l, r) => l.label.localeCompare(r.label));
                return products;
            }));
    }

    public getPsProducts(siteId: string): Observable<PsProduct[]> {
        return this.http.get<PsProduct[]>(this.settings.apiBaseUrl + url`psProducts/${siteId}/products`);
    }

    public getProductsByCustomer(
            siteId: string,
            subinventoryId: number,
            customerId: number,
            poolerId: number,
            loadedDate: DateTime,
            loadType: string): Observable<number[]> {
        return this.http.get<number[]>(this.settings.apiBaseUrl + url`customer/products?siteId=${
            siteId
        }&subinventoryId=${
            subinventoryId
        }&customerId=${
            customerId
        }&poolerId=${
            poolerId
        }&loadedDate=${
            loadedDate.toISODate()
        }&loadType=${
            loadType
        }`);
    }
}
